import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'mojo-notifications-loader',
  templateUrl: './notifications-loader.component.html',
  styleUrls: ['./notifications-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationsLoaderComponent {
  numberOfLoadingElements = 2;
}
